import React, { useState, useEffect, useRef, useLayoutEffect } from 'react';
import { Container, Row, Col, Form, Button, Spinner, Alert, Card } from 'react-bootstrap';
import { useDispatch, useSelector } from "react-redux";
import { currencyModification, getSingleCurrency } from "./currencyAction";
import { useForm } from "react-hook-form";
import { useParams , useNavigate, Link} from 'react-router-dom';
import Swal from 'sweetalert2';
import { getAllCurrency } from "./currencyAction";
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import {  FaArrowLeft } from 'react-icons/fa';


const initialState = {
  id: "",
  country: "",
  currency: "",
  currencycode: "",
  status: "",

}



const ModifyCountry = () => {
  let navigate = useNavigate();
    const {id}=useParams();
  //  console.log('modify'+id);
    const { curisLoading, curmstatus, curmmessage } = useSelector((state) => state.currencyList);

    const dispatch = useDispatch();
    
    const [currencies, setCurrencies] = useState({
      id:"",
      currency:"",
      country:"",
      currencycode:"",
      status:""
    });
    
    //const [country, setCountry] = useState('');
    const [status, setStatus] = useState(0);
    const [modify, setModify] = useState(0);
    const [defaultValue, setDefaultValue] = useState(null);
    const [defaultValue2, setDefaultValue2] = useState(null);
    const [defaultValue3, setDefaultValue3] = useState(null);

  
    
    const currencyData = useSelector((state) => state.currencyList);
    
   useEffect(() => {
    dispatch(getAllCurrency());
    dispatch(getSingleCurrency(id));
   
}, []);

   
 
    const { register, handleSubmit, formState: { errors } } = useForm();

   
  
   const uData = JSON.parse(JSON.stringify(currencyData.currencies));


   useEffect(() => {
    // Find the default value based on uData.country_name when the component mounts
    const defaultCountry = countries.find((option) => option.country === uData?.country_name);
    setDefaultValue(defaultCountry);

    const defaultCurrencyname = currencyNames.find((option) => option === uData?.currency_name);
    setDefaultValue2(defaultCurrencyname);

    const defaultCurrencycode = currencies2.find((option) => option.code === uData?.currency_code);
    setDefaultValue3(defaultCurrencycode);
  }, [ uData?.country_name, uData?.currency_name, uData?.currency_code]);

   useEffect(() => {
    if (currencyData && currencyData.currencies && currencyData.currencies.id === Number(id)) {
      const uData = JSON.parse(JSON.stringify(currencyData.currencies));
      const initialRates = Object.keys(uData).map((key) => (uData[key] || '').toString());
      setCurrencies((prevState) => ({
        ...prevState,
        id: id,
        currency: uData?.currency_name,
        country:  uData?.country_name,
        currencycode:  uData?.currency_code,
        status:  uData?.status
      }));
    }
  }, [currencyData, id]);


  const handleOnChange = e => {
    const name = e.target.name;
    const value = e.target.value;
   
    setCurrencies({ ...currencies, [name]: value });
  
  };
  const handleCountryName = (event,value) => {

    if(value){
      setCurrencies({ ...currencies,"country": value.country });
      const defaultCountry = countries.find((option) => option.country === value.country);
      setDefaultValue(defaultCountry);


    }else{
      setCurrencies({ ...currencies,"country": "" });


    }

 
 
  };

  const handleCurrencyName = (event,value) => {
    if(value){

      setCurrencies({ ...currencies, "currency": value });
      const defaultCurrencyname = currencyNames.find((option) => option === value);
      setDefaultValue2(defaultCurrencyname);


    }else{
      setCurrencies({ ...currencies, "currency": "" });


    }

 
 
  };
  const handleCurrencyCode = (event, value) => {
    if (value) {
      setCurrencies({ ...currencies, "currencycode": value.code });
    const defaultCurrencycode = currencies2.find((option) => option.code === value.code);
    setDefaultValue3(defaultCurrencycode);

    } else {
      setCurrencies({ ...currencies, "currencycode": "" });


      
    }
  };

 
  const handleOnSubmit = (e) => {
    e.preventDefault();
  
    const { id,country, currency, currencycode, status
    } = currencies;
    if (country === "" && currency === "" && status === "" && currencycode==="") {
      Swal.fire('No changes made!', '', 'info');
      navigate('/currencyList');
      return;
    }
    const countryUpdation1 = {
      id,
      country,
      currency,
      currencycode,
      status
    };
    Swal.fire('Currency Updated Successfully!', '', 'success')
   
    dispatch(currencyModification(countryUpdation1));
    setModify(1);
    navigate('/currencyList');
  
  
  };

 
  return (
    <>
      {/* <Container className="my-4 mx-4 container-xl ">

	  <Card  style={{marginLeft:'100px',marginTop:'-60px'}}>
          <Card.Header><h4 className="d-flex text-dark text-left mt-2 mb-2">Modify Currency</h4></Card.Header>
          <Card.Body>
		  <Row>
              <Col>
      
              <Link to="/currencyList"><span className="badge bg-success" style={{backgroundColor:'rgb(156 186 237)',color:'white'}}><FaArrowLeft />&nbsp;Go Back</span></Link> 
   
              <br />
              </Col>
            </Row> */}
			<div className="my-4  container-xl">
                <div className="card" style={{marginTop:'-50px'}}>
                    <div className="card-header">
                        <h3 className="d-flex text-dark text-left mt-2 mb-2"   style={{fontFamily:'Times New Roman' , fontWeight:'600'}}>Modify Currency</h3>
                    </div>
                    <div className="card-body">
                        <Row>
                            <Link to="/currencyList"><span className="badge bg-success" style={{backgroundColor:'rgb(156 186 237)',color:'white'}}><FaArrowLeft />&nbsp;Go Back</span></Link> 
   
                        </Row>
                        <br />
            <Form className=" mx-4 my-2" component="form" noValidate   autoComplete="off" onSubmit={handleOnSubmit}>
              <Row className="mb-3">
              <Form.Group as={Col} controlId="formGridCurrency">
                <Form.Label>Country Name</Form.Label>
                  <Autocomplete
                    id="country-select-demo"
                    sx={{ width: 360 }}
                    options={countries}
                    autoHighlight
                    name="country"
                    value={defaultValue}
                    getOptionLabel={(option) => option.country}
                    renderOption={(props, option) => (
                      <Box component="li" sx={{ '& > img': { mr: 2, flexShrink: 0 } }} {...props}>
                        <img
                          loading="lazy"
                          width="20"
                          src={`https://flagcdn.com/w20/${option.code.toLowerCase()}.png`}
                          srcSet={`https://flagcdn.com/w40/${option.code.toLowerCase()}.png 2x`}
                          alt=""
                        />
                        {option.country}
                      </Box>
                    )}
                    onChange={handleCountryName}

                    renderInput={(params) => (
                      <TextField
                        {...params}
                        name='country'
                        // label="Choose a country"
                        inputProps={{
                          ...params.inputProps,
                          autoComplete: 'new-password', // disable autocomplete and autofill
                        }}
                      />
                    )}
                  />
                </Form.Group>
                <Form.Group as={Col} controlId="formGridUsername">
                  <Form.Label>Currency Name</Form.Label>
                  <Form.Control type="hidden" name="id" autoComplete='off' value={id} />
                  <Autocomplete
                    id="country-select-demo"
                    sx={{ width: 360 }}
                    options={currencyNames}
                    autoHighlight
                    name="currency"
                    value={defaultValue2}
                    getOptionLabel={(option) => option}
                    renderOption={(props, option) => (
                      <Box component="li" sx={{ '& > img': { mr: 2, flexShrink: 0 } }} {...props}>
                        
                        {option} 
                      </Box>
                    )}
                    onChange={handleCurrencyName}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        // label="Choose a country"
                        inputProps={{
                          ...params.inputProps,
                          autoComplete: 'new-password', // disable autocomplete and autofill
                        }}
                      />
                    )}
                  /> 
                  
                  
                  </Form.Group>
                  </Row>
                  <Row className="mb-3">

                 <Form.Group as={Col} controlId="formGridCurrencyCode">
                  <Form.Label>Currency Code</Form.Label>
                  <Autocomplete
                    id="country-select-demo"
                    sx={{ width: 360 }}
                    options={currencies2}
                    autoHighlight
                    name="currencycode"
                    value={defaultValue3}
                    getOptionLabel={(option) => option.code}
                    
                    renderOption={(props, option) => (
                      <Box component="li" sx={{ '& > img': { mr: 2, flexShrink: 0 } }} {...props}>
                        
                       {option.code}({option.symbol})
                      </Box>
                    )}
                    onChange={handleCurrencyCode}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        // label="Choose a country"
                        inputProps={{
                          ...params.inputProps,
                          autoComplete: 'new-password', // disable autocomplete and autofill
                        }}
                      />
                    )}
                  />             
                   </Form.Group>
                
              
                <Form.Group as={Col} controlId="formGridStatus">
                  <Form.Label>Status</Form.Label>
                  <Form.Select required name="status"  style={{height:"55px"}}  value={currencies.status}  {...register("status")} onChange={handleOnChange}>
                    
                    <option value="">Choose..</option>
                    <option value="1">Enable</option>
                    <option value="0">Disable</option>
                  </Form.Select>
                  {errors.status && <p className='text-danger'>Status required</p>}
                </Form.Group>
              </Row>
              <div class="d-grid  col-2 mx-auto">
              <Button variant="primary" type="submit" className='align-middle'>
                Submit
              </Button>
              </div>
              {curisLoading && (<Spinner variant='info' animation='border' />)}

            </Form>
			</div>
			</div>
			</div>
         
    </>
  );
}

const currencyNames = [
  "US Dollar",
  "Canadian Dollar",
  "Euro",
  "United Arab Emirates Dirham",
  "Afghan Afghani",
  "Albanian Lek",
  "Armenian Dram",
  "Argentine Peso",
  "Australian Dollar",
  "Azerbaijani Manat",
  "Bosnia-Herzegovina Convertible Mark",
  "Bangladeshi Taka",
  "Bulgarian Lev",
  "Bahraini Dinar",
  "Burundian Franc",
  "Brunei Dollar",
  "Bolivian Boliviano",
  "Brazilian Real",
  "Botswanan Pula",
  "Belarusian Ruble",
  "Belize Dollar",
  "Congolese Franc",
  "Swiss Franc",
  "Chilean Peso",
  "Chinese Yuan",
  "Colombian Peso",
  "Costa Rican Colón",
  "Cape Verdean Escudo",
  "Czech Republic Koruna",
  "Djiboutian Franc",
  "Danish Krone",
  "Dominican Peso",
  "Algerian Dinar",
  "Estonian Kroon",
  "Egyptian Pound",
  "Eritrean Nakfa",
  "Ethiopian Birr",
  "British Pound Sterling",
  "Georgian Lari",
  "Ghanaian Cedi",
  "Guinean Franc",
  "Guatemalan Quetzal",
  "Hong Kong Dollar",
  "Honduran Lempira",
  "Croatian Kuna",
  "Hungarian Forint",
  "Indonesian Rupiah",
  "Israeli New Sheqel",
  "Indian Rupee",
  "Iraqi Dinar",
  "Iranian Rial",
  "Icelandic Króna",
  "Jamaican Dollar",
  "Jordanian Dinar",
  "Japanese Yen",
  "Kenyan Shilling",
  "Cambodian Riel",
  "Comorian Franc",
  "South Korean Won",
  "Kuwaiti Dinar",
  "Kazakhstani Tenge",
  "Lebanese Pound",
  "Sri Lankan Rupee",
  "Lithuanian Litas",
  "Latvian Lats",
  "Libyan Dinar",
  "Moroccan Dirham",
  "Moldovan Leu",
  "Malagasy Ariary",
  "Macedonian Denar",
  "Myanma Kyat",
  "Macanese Pataca",
  "Mauritian Rupee",
  "Mexican Peso",
  "Malaysian Ringgit",
  "Mozambican Metical",
  "Namibian Dollar",
  "Nigerian Naira",
  "Nicaraguan Córdoba",
  "Norwegian Krone",
  "Nepalese Rupee",
  "New Zealand Dollar",
  "Omani Rial",
  "Panamanian Balboa",
  "Peruvian Nuevo Sol",
  "Philippine Peso",
  "Pakistani Rupee",
  "Polish Zloty",
  "Paraguayan Guarani",
  "Qatari Rial",
  "Romanian Leu",
  "Serbian Dinar",
  "Russian Ruble",
  "Rwandan Franc",
  "Saudi Riyal",
  "Sudanese Pound",
  "Swedish Krona",
  "Singapore Dollar",
  "Somali Shilling",
  "Syrian Pound",
  "Thai Baht",
  "Tunisian Dinar",
  "Tongan Paʻanga",
  "Turkish Lira",
  "Trinidad and Tobago Dollar",
  "New Taiwan Dollar",
  "Tanzanian Shilling",
  "Ukrainian Hryvnia",
  "Ugandan Shilling",
  "Uruguayan Peso",
  "Uzbekistan Som",
  "Venezuelan Bolívar",
  "Vietnamese Dong",
  "CFA Franc BEAC",
  "CFA Franc BCEAO",
  "Yemeni Rial",
  "South African Rand",
  "Zambian Kwacha"
];


const currencies2 = [{
	"symbol": "$",
	"name": "US Dollar",
	"symbol_native": "$",
	"decimal_digits": 2,
	"rounding": 0,
	"code": "USD",
	"name_plural": "US dollars"
}, {
	"symbol": "CA$",
	"name": "Canadian Dollar",
	"symbol_native": "$",
	"decimal_digits": 2,
	"rounding": 0,
	"code": "CAD",
	"name_plural": "Canadian dollars"
}, {
	"symbol": "€",
	"name": "Euro",
	"symbol_native": "€",
	"decimal_digits": 2,
	"rounding": 0,
	"code": "EUR",
	"name_plural": "euros"
}, {
	"symbol": "AED",
	"name": "United Arab Emirates Dirham",
	"symbol_native": "د.إ.‏",
	"decimal_digits": 2,
	"rounding": 0,
	"code": "AED",
	"name_plural": "UAE dirhams"
}, {
	"symbol": "Af",
	"name": "Afghan Afghani",
	"symbol_native": "؋",
	"decimal_digits": 0,
	"rounding": 0,
	"code": "AFN",
	"name_plural": "Afghan Afghanis"
}, {
	"symbol": "ALL",
	"name": "Albanian Lek",
	"symbol_native": "Lek",
	"decimal_digits": 0,
	"rounding": 0,
	"code": "ALL",
	"name_plural": "Albanian lekë"
}, {
	"symbol": "AMD",
	"name": "Armenian Dram",
	"symbol_native": "դր.",
	"decimal_digits": 0,
	"rounding": 0,
	"code": "AMD",
	"name_plural": "Armenian drams"
}, {
	"symbol": "AR$",
	"name": "Argentine Peso",
	"symbol_native": "$",
	"decimal_digits": 2,
	"rounding": 0,
	"code": "ARS",
	"name_plural": "Argentine pesos"
}, {
	"symbol": "AU$",
	"name": "Australian Dollar",
	"symbol_native": "$",
	"decimal_digits": 2,
	"rounding": 0,
	"code": "AUD",
	"name_plural": "Australian dollars"
}, {
	"symbol": "man.",
	"name": "Azerbaijani Manat",
	"symbol_native": "ман.",
	"decimal_digits": 2,
	"rounding": 0,
	"code": "AZN",
	"name_plural": "Azerbaijani manats"
}, {
	"symbol": "KM",
	"name": "Bosnia-Herzegovina Convertible Mark",
	"symbol_native": "KM",
	"decimal_digits": 2,
	"rounding": 0,
	"code": "BAM",
	"name_plural": "Bosnia-Herzegovina convertible marks"
}, {
	"symbol": "Tk",
	"name": "Bangladeshi Taka",
	"symbol_native": "৳",
	"decimal_digits": 2,
	"rounding": 0,
	"code": "BDT",
	"name_plural": "Bangladeshi takas"
}, {
	"symbol": "BGN",
	"name": "Bulgarian Lev",
	"symbol_native": "лв.",
	"decimal_digits": 2,
	"rounding": 0,
	"code": "BGN",
	"name_plural": "Bulgarian leva"
}, {
	"symbol": "BD",
	"name": "Bahraini Dinar",
	"symbol_native": "د.ب.‏",
	"decimal_digits": 3,
	"rounding": 0,
	"code": "BHD",
	"name_plural": "Bahraini dinars"
}, {
	"symbol": "FBu",
	"name": "Burundian Franc",
	"symbol_native": "FBu",
	"decimal_digits": 0,
	"rounding": 0,
	"code": "BIF",
	"name_plural": "Burundian francs"
}, {
	"symbol": "BN$",
	"name": "Brunei Dollar",
	"symbol_native": "$",
	"decimal_digits": 2,
	"rounding": 0,
	"code": "BND",
	"name_plural": "Brunei dollars"
}, {
	"symbol": "Bs",
	"name": "Bolivian Boliviano",
	"symbol_native": "Bs",
	"decimal_digits": 2,
	"rounding": 0,
	"code": "BOB",
	"name_plural": "Bolivian bolivianos"
}, {
	"symbol": "R$",
	"name": "Brazilian Real",
	"symbol_native": "R$",
	"decimal_digits": 2,
	"rounding": 0,
	"code": "BRL",
	"name_plural": "Brazilian reals"
}, {
	"symbol": "BWP",
	"name": "Botswanan Pula",
	"symbol_native": "P",
	"decimal_digits": 2,
	"rounding": 0,
	"code": "BWP",
	"name_plural": "Botswanan pulas"
}, {
	"symbol": "BYR",
	"name": "Belarusian Ruble",
	"symbol_native": "BYR",
	"decimal_digits": 0,
	"rounding": 0,
	"code": "BYR",
	"name_plural": "Belarusian rubles"
}, {
	"symbol": "BZ$",
	"name": "Belize Dollar",
	"symbol_native": "$",
	"decimal_digits": 2,
	"rounding": 0,
	"code": "BZD",
	"name_plural": "Belize dollars"
}, {
	"symbol": "CDF",
	"name": "Congolese Franc",
	"symbol_native": "FrCD",
	"decimal_digits": 2,
	"rounding": 0,
	"code": "CDF",
	"name_plural": "Congolese francs"
}, {
	"symbol": "CHF",
	"name": "Swiss Franc",
	"symbol_native": "CHF",
	"decimal_digits": 2,
	"rounding": 0.05,
	"code": "CHF",
	"name_plural": "Swiss francs"
}, {
	"symbol": "CL$",
	"name": "Chilean Peso",
	"symbol_native": "$",
	"decimal_digits": 0,
	"rounding": 0,
	"code": "CLP",
	"name_plural": "Chilean pesos"
}, {
	"symbol": "CN¥",
	"name": "Chinese Yuan",
	"symbol_native": "CN¥",
	"decimal_digits": 2,
	"rounding": 0,
	"code": "CNY",
	"name_plural": "Chinese yuan"
}, {
	"symbol": "CO$",
	"name": "Colombian Peso",
	"symbol_native": "$",
	"decimal_digits": 0,
	"rounding": 0,
	"code": "COP",
	"name_plural": "Colombian pesos"
}, {
	"symbol": "₡",
	"name": "Costa Rican Colón",
	"symbol_native": "₡",
	"decimal_digits": 0,
	"rounding": 0,
	"code": "CRC",
	"name_plural": "Costa Rican colóns"
}, {
	"symbol": "CV$",
	"name": "Cape Verdean Escudo",
	"symbol_native": "CV$",
	"decimal_digits": 2,
	"rounding": 0,
	"code": "CVE",
	"name_plural": "Cape Verdean escudos"
}, {
	"symbol": "Kč",
	"name": "Czech Republic Koruna",
	"symbol_native": "Kč",
	"decimal_digits": 2,
	"rounding": 0,
	"code": "CZK",
	"name_plural": "Czech Republic korunas"
}, {
	"symbol": "Fdj",
	"name": "Djiboutian Franc",
	"symbol_native": "Fdj",
	"decimal_digits": 0,
	"rounding": 0,
	"code": "DJF",
	"name_plural": "Djiboutian francs"
}, {
	"symbol": "Dkr",
	"name": "Danish Krone",
	"symbol_native": "kr",
	"decimal_digits": 2,
	"rounding": 0,
	"code": "DKK",
	"name_plural": "Danish kroner"
}, {
	"symbol": "RD$",
	"name": "Dominican Peso",
	"symbol_native": "RD$",
	"decimal_digits": 2,
	"rounding": 0,
	"code": "DOP",
	"name_plural": "Dominican pesos"
}, {
	"symbol": "DA",
	"name": "Algerian Dinar",
	"symbol_native": "د.ج.‏",
	"decimal_digits": 2,
	"rounding": 0,
	"code": "DZD",
	"name_plural": "Algerian dinars"
}, {
	"symbol": "Ekr",
	"name": "Estonian Kroon",
	"symbol_native": "kr",
	"decimal_digits": 2,
	"rounding": 0,
	"code": "EEK",
	"name_plural": "Estonian kroons"
}, {
	"symbol": "EGP",
	"name": "Egyptian Pound",
	"symbol_native": "ج.م.‏",
	"decimal_digits": 2,
	"rounding": 0,
	"code": "EGP",
	"name_plural": "Egyptian pounds"
}, {
	"symbol": "Nfk",
	"name": "Eritrean Nakfa",
	"symbol_native": "Nfk",
	"decimal_digits": 2,
	"rounding": 0,
	"code": "ERN",
	"name_plural": "Eritrean nakfas"
}, {
	"symbol": "Br",
	"name": "Ethiopian Birr",
	"symbol_native": "Br",
	"decimal_digits": 2,
	"rounding": 0,
	"code": "ETB",
	"name_plural": "Ethiopian birrs"
}, {
	"symbol": "£",
	"name": "British Pound Sterling",
	"symbol_native": "£",
	"decimal_digits": 2,
	"rounding": 0,
	"code": "GBP",
	"name_plural": "British pounds sterling"
}, {
	"symbol": "GEL",
	"name": "Georgian Lari",
	"symbol_native": "GEL",
	"decimal_digits": 2,
	"rounding": 0,
	"code": "GEL",
	"name_plural": "Georgian laris"
}, {
	"symbol": "GH₵",
	"name": "Ghanaian Cedi",
	"symbol_native": "GH₵",
	"decimal_digits": 2,
	"rounding": 0,
	"code": "GHS",
	"name_plural": "Ghanaian cedis"
}, {
	"symbol": "FG",
	"name": "Guinean Franc",
	"symbol_native": "FG",
	"decimal_digits": 0,
	"rounding": 0,
	"code": "GNF",
	"name_plural": "Guinean francs"
}, {
	"symbol": "GTQ",
	"name": "Guatemalan Quetzal",
	"symbol_native": "Q",
	"decimal_digits": 2,
	"rounding": 0,
	"code": "GTQ",
	"name_plural": "Guatemalan quetzals"
}, {
	"symbol": "HK$",
	"name": "Hong Kong Dollar",
	"symbol_native": "$",
	"decimal_digits": 2,
	"rounding": 0,
	"code": "HKD",
	"name_plural": "Hong Kong dollars"
}, {
	"symbol": "HNL",
	"name": "Honduran Lempira",
	"symbol_native": "L",
	"decimal_digits": 2,
	"rounding": 0,
	"code": "HNL",
	"name_plural": "Honduran lempiras"
}, {
	"symbol": "kn",
	"name": "Croatian Kuna",
	"symbol_native": "kn",
	"decimal_digits": 2,
	"rounding": 0,
	"code": "HRK",
	"name_plural": "Croatian kunas"
}, {
	"symbol": "Ft",
	"name": "Hungarian Forint",
	"symbol_native": "Ft",
	"decimal_digits": 0,
	"rounding": 0,
	"code": "HUF",
	"name_plural": "Hungarian forints"
}, {
	"symbol": "Rp",
	"name": "Indonesian Rupiah",
	"symbol_native": "Rp",
	"decimal_digits": 0,
	"rounding": 0,
	"code": "IDR",
	"name_plural": "Indonesian rupiahs"
}, {
	"symbol": "₪",
	"name": "Israeli New Sheqel",
	"symbol_native": "₪",
	"decimal_digits": 2,
	"rounding": 0,
	"code": "ILS",
	"name_plural": "Israeli new sheqels"
}, {
	"symbol": "Rs",
	"name": "Indian Rupee",
	"symbol_native": "টকা",
	"decimal_digits": 2,
	"rounding": 0,
	"code": "INR",
	"name_plural": "Indian rupees"
}, {
	"symbol": "IQD",
	"name": "Iraqi Dinar",
	"symbol_native": "د.ع.‏",
	"decimal_digits": 0,
	"rounding": 0,
	"code": "IQD",
	"name_plural": "Iraqi dinars"
}, {
	"symbol": "IRR",
	"name": "Iranian Rial",
	"symbol_native": "﷼",
	"decimal_digits": 0,
	"rounding": 0,
	"code": "IRR",
	"name_plural": "Iranian rials"
}, {
	"symbol": "Ikr",
	"name": "Icelandic Króna",
	"symbol_native": "kr",
	"decimal_digits": 0,
	"rounding": 0,
	"code": "ISK",
	"name_plural": "Icelandic krónur"
}, {
	"symbol": "J$",
	"name": "Jamaican Dollar",
	"symbol_native": "$",
	"decimal_digits": 2,
	"rounding": 0,
	"code": "JMD",
	"name_plural": "Jamaican dollars"
}, {
	"symbol": "JD",
	"name": "Jordanian Dinar",
	"symbol_native": "د.أ.‏",
	"decimal_digits": 3,
	"rounding": 0,
	"code": "JOD",
	"name_plural": "Jordanian dinars"
}, {
	"symbol": "¥",
	"name": "Japanese Yen",
	"symbol_native": "￥",
	"decimal_digits": 0,
	"rounding": 0,
	"code": "JPY",
	"name_plural": "Japanese yen"
}, {
	"symbol": "Ksh",
	"name": "Kenyan Shilling",
	"symbol_native": "Ksh",
	"decimal_digits": 2,
	"rounding": 0,
	"code": "KES",
	"name_plural": "Kenyan shillings"
}, {
	"symbol": "KHR",
	"name": "Cambodian Riel",
	"symbol_native": "៛",
	"decimal_digits": 2,
	"rounding": 0,
	"code": "KHR",
	"name_plural": "Cambodian riels"
}, {
	"symbol": "CF",
	"name": "Comorian Franc",
	"symbol_native": "FC",
	"decimal_digits": 0,
	"rounding": 0,
	"code": "KMF",
	"name_plural": "Comorian francs"
}, {
	"symbol": "₩",
	"name": "South Korean Won",
	"symbol_native": "₩",
	"decimal_digits": 0,
	"rounding": 0,
	"code": "KRW",
	"name_plural": "South Korean won"
}, {
	"symbol": "KD",
	"name": "Kuwaiti Dinar",
	"symbol_native": "د.ك.‏",
	"decimal_digits": 3,
	"rounding": 0,
	"code": "KWD",
	"name_plural": "Kuwaiti dinars"
}, {
	"symbol": "KZT",
	"name": "Kazakhstani Tenge",
	"symbol_native": "тңг.",
	"decimal_digits": 2,
	"rounding": 0,
	"code": "KZT",
	"name_plural": "Kazakhstani tenges"
}, {
	"symbol": "LB£",
	"name": "Lebanese Pound",
	"symbol_native": "ل.ل.‏",
	"decimal_digits": 0,
	"rounding": 0,
	"code": "LBP",
	"name_plural": "Lebanese pounds"
}, {
	"symbol": "SLRs",
	"name": "Sri Lankan Rupee",
	"symbol_native": "SL Re",
	"decimal_digits": 2,
	"rounding": 0,
	"code": "LKR",
	"name_plural": "Sri Lankan rupees"
}, {
	"symbol": "Lt",
	"name": "Lithuanian Litas",
	"symbol_native": "Lt",
	"decimal_digits": 2,
	"rounding": 0,
	"code": "LTL",
	"name_plural": "Lithuanian litai"
}, {
	"symbol": "Ls",
	"name": "Latvian Lats",
	"symbol_native": "Ls",
	"decimal_digits": 2,
	"rounding": 0,
	"code": "LVL",
	"name_plural": "Latvian lati"
}, {
	"symbol": "LD",
	"name": "Libyan Dinar",
	"symbol_native": "د.ل.‏",
	"decimal_digits": 3,
	"rounding": 0,
	"code": "LYD",
	"name_plural": "Libyan dinars"
}, {
	"symbol": "MAD",
	"name": "Moroccan Dirham",
	"symbol_native": "د.م.‏",
	"decimal_digits": 2,
	"rounding": 0,
	"code": "MAD",
	"name_plural": "Moroccan dirhams"
}, {
	"symbol": "MDL",
	"name": "Moldovan Leu",
	"symbol_native": "MDL",
	"decimal_digits": 2,
	"rounding": 0,
	"code": "MDL",
	"name_plural": "Moldovan lei"
}, {
	"symbol": "MGA",
	"name": "Malagasy Ariary",
	"symbol_native": "MGA",
	"decimal_digits": 0,
	"rounding": 0,
	"code": "MGA",
	"name_plural": "Malagasy Ariaries"
}, {
	"symbol": "MKD",
	"name": "Macedonian Denar",
	"symbol_native": "MKD",
	"decimal_digits": 2,
	"rounding": 0,
	"code": "MKD",
	"name_plural": "Macedonian denari"
}, {
	"symbol": "MMK",
	"name": "Myanma Kyat",
	"symbol_native": "K",
	"decimal_digits": 0,
	"rounding": 0,
	"code": "MMK",
	"name_plural": "Myanma kyats"
}, {
	"symbol": "MOP$",
	"name": "Macanese Pataca",
	"symbol_native": "MOP$",
	"decimal_digits": 2,
	"rounding": 0,
	"code": "MOP",
	"name_plural": "Macanese patacas"
}, {
	"symbol": "MURs",
	"name": "Mauritian Rupee",
	"symbol_native": "MURs",
	"decimal_digits": 0,
	"rounding": 0,
	"code": "MUR",
	"name_plural": "Mauritian rupees"
}, {
	"symbol": "MX$",
	"name": "Mexican Peso",
	"symbol_native": "$",
	"decimal_digits": 2,
	"rounding": 0,
	"code": "MXN",
	"name_plural": "Mexican pesos"
}, {
	"symbol": "RM",
	"name": "Malaysian Ringgit",
	"symbol_native": "RM",
	"decimal_digits": 2,
	"rounding": 0,
	"code": "MYR",
	"name_plural": "Malaysian ringgits"
}, {
	"symbol": "MTn",
	"name": "Mozambican Metical",
	"symbol_native": "MTn",
	"decimal_digits": 2,
	"rounding": 0,
	"code": "MZN",
	"name_plural": "Mozambican meticals"
}, {
	"symbol": "N$",
	"name": "Namibian Dollar",
	"symbol_native": "N$",
	"decimal_digits": 2,
	"rounding": 0,
	"code": "NAD",
	"name_plural": "Namibian dollars"
}, {
	"symbol": "₦",
	"name": "Nigerian Naira",
	"symbol_native": "₦",
	"decimal_digits": 2,
	"rounding": 0,
	"code": "NGN",
	"name_plural": "Nigerian nairas"
}, {
	"symbol": "C$",
	"name": "Nicaraguan Córdoba",
	"symbol_native": "C$",
	"decimal_digits": 2,
	"rounding": 0,
	"code": "NIO",
	"name_plural": "Nicaraguan córdobas"
}, {
	"symbol": "Nkr",
	"name": "Norwegian Krone",
	"symbol_native": "kr",
	"decimal_digits": 2,
	"rounding": 0,
	"code": "NOK",
	"name_plural": "Norwegian kroner"
}, {
	"symbol": "NPRs",
	"name": "Nepalese Rupee",
	"symbol_native": "नेरू",
	"decimal_digits": 2,
	"rounding": 0,
	"code": "NPR",
	"name_plural": "Nepalese rupees"
}, {
	"symbol": "NZ$",
	"name": "New Zealand Dollar",
	"symbol_native": "$",
	"decimal_digits": 2,
	"rounding": 0,
	"code": "NZD",
	"name_plural": "New Zealand dollars"
}, {
	"symbol": "OMR",
	"name": "Omani Rial",
	"symbol_native": "ر.ع.‏",
	"decimal_digits": 3,
	"rounding": 0,
	"code": "OMR",
	"name_plural": "Omani rials"
}, {
	"symbol": "B/.",
	"name": "Panamanian Balboa",
	"symbol_native": "B/.",
	"decimal_digits": 2,
	"rounding": 0,
	"code": "PAB",
	"name_plural": "Panamanian balboas"
}, {
	"symbol": "S/.",
	"name": "Peruvian Nuevo Sol",
	"symbol_native": "S/.",
	"decimal_digits": 2,
	"rounding": 0,
	"code": "PEN",
	"name_plural": "Peruvian nuevos soles"
}, {
	"symbol": "₱",
	"name": "Philippine Peso",
	"symbol_native": "₱",
	"decimal_digits": 2,
	"rounding": 0,
	"code": "PHP",
	"name_plural": "Philippine pesos"
}, {
	"symbol": "PKRs",
	"name": "Pakistani Rupee",
	"symbol_native": "₨",
	"decimal_digits": 0,
	"rounding": 0,
	"code": "PKR",
	"name_plural": "Pakistani rupees"
}, {
	"symbol": "zł",
	"name": "Polish Zloty",
	"symbol_native": "zł",
	"decimal_digits": 2,
	"rounding": 0,
	"code": "PLN",
	"name_plural": "Polish zlotys"
}, {
	"symbol": "₲",
	"name": "Paraguayan Guarani",
	"symbol_native": "₲",
	"decimal_digits": 0,
	"rounding": 0,
	"code": "PYG",
	"name_plural": "Paraguayan guaranis"
}, {
	"symbol": "QR",
	"name": "Qatari Rial",
	"symbol_native": "ر.ق.‏",
	"decimal_digits": 2,
	"rounding": 0,
	"code": "QAR",
	"name_plural": "Qatari rials"
}, {
	"symbol": "RON",
	"name": "Romanian Leu",
	"symbol_native": "RON",
	"decimal_digits": 2,
	"rounding": 0,
	"code": "RON",
	"name_plural": "Romanian lei"
}, {
	"symbol": "din.",
	"name": "Serbian Dinar",
	"symbol_native": "дин.",
	"decimal_digits": 0,
	"rounding": 0,
	"code": "RSD",
	"name_plural": "Serbian dinars"
}, {
	"symbol": "RUB",
	"name": "Russian Ruble",
	"symbol_native": "руб.",
	"decimal_digits": 2,
	"rounding": 0,
	"code": "RUB",
	"name_plural": "Russian rubles"
}, {
	"symbol": "RWF",
	"name": "Rwandan Franc",
	"symbol_native": "FR",
	"decimal_digits": 0,
	"rounding": 0,
	"code": "RWF",
	"name_plural": "Rwandan francs"
}, {
	"symbol": "SR",
	"name": "Saudi Riyal",
	"symbol_native": "ر.س.‏",
	"decimal_digits": 2,
	"rounding": 0,
	"code": "SAR",
	"name_plural": "Saudi riyals"
}, {
	"symbol": "SDG",
	"name": "Sudanese Pound",
	"symbol_native": "SDG",
	"decimal_digits": 2,
	"rounding": 0,
	"code": "SDG",
	"name_plural": "Sudanese pounds"
}, {
	"symbol": "Skr",
	"name": "Swedish Krona",
	"symbol_native": "kr",
	"decimal_digits": 2,
	"rounding": 0,
	"code": "SEK",
	"name_plural": "Swedish kronor"
}, {
	"symbol": "S$",
	"name": "Singapore Dollar",
	"symbol_native": "$",
	"decimal_digits": 2,
	"rounding": 0,
	"code": "SGD",
	"name_plural": "Singapore dollars"
}, {
	"symbol": "Ssh",
	"name": "Somali Shilling",
	"symbol_native": "Ssh",
	"decimal_digits": 0,
	"rounding": 0,
	"code": "SOS",
	"name_plural": "Somali shillings"
}, {
	"symbol": "SY£",
	"name": "Syrian Pound",
	"symbol_native": "ل.س.‏",
	"decimal_digits": 0,
	"rounding": 0,
	"code": "SYP",
	"name_plural": "Syrian pounds"
}, {
	"symbol": "฿",
	"name": "Thai Baht",
	"symbol_native": "฿",
	"decimal_digits": 2,
	"rounding": 0,
	"code": "THB",
	"name_plural": "Thai baht"
}, {
	"symbol": "DT",
	"name": "Tunisian Dinar",
	"symbol_native": "د.ت.‏",
	"decimal_digits": 3,
	"rounding": 0,
	"code": "TND",
	"name_plural": "Tunisian dinars"
}, {
	"symbol": "T$",
	"name": "Tongan Paʻanga",
	"symbol_native": "T$",
	"decimal_digits": 2,
	"rounding": 0,
	"code": "TOP",
	"name_plural": "Tongan paʻanga"
}, {
	"symbol": "TL",
	"name": "Turkish Lira",
	"symbol_native": "TL",
	"decimal_digits": 2,
	"rounding": 0,
	"code": "TRY",
	"name_plural": "Turkish Lira"
}, {
	"symbol": "TT$",
	"name": "Trinidad and Tobago Dollar",
	"symbol_native": "$",
	"decimal_digits": 2,
	"rounding": 0,
	"code": "TTD",
	"name_plural": "Trinidad and Tobago dollars"
}, {
	"symbol": "NT$",
	"name": "New Taiwan Dollar",
	"symbol_native": "NT$",
	"decimal_digits": 2,
	"rounding": 0,
	"code": "TWD",
	"name_plural": "New Taiwan dollars"
}, {
	"symbol": "TSh",
	"name": "Tanzanian Shilling",
	"symbol_native": "TSh",
	"decimal_digits": 0,
	"rounding": 0,
	"code": "TZS",
	"name_plural": "Tanzanian shillings"
}, {
	"symbol": "₴",
	"name": "Ukrainian Hryvnia",
	"symbol_native": "₴",
	"decimal_digits": 2,
	"rounding": 0,
	"code": "UAH",
	"name_plural": "Ukrainian hryvnias"
}, {
	"symbol": "USh",
	"name": "Ugandan Shilling",
	"symbol_native": "USh",
	"decimal_digits": 0,
	"rounding": 0,
	"code": "UGX",
	"name_plural": "Ugandan shillings"
}, {
	"symbol": "$U",
	"name": "Uruguayan Peso",
	"symbol_native": "$",
	"decimal_digits": 2,
	"rounding": 0,
	"code": "UYU",
	"name_plural": "Uruguayan pesos"
}, {
	"symbol": "UZS",
	"name": "Uzbekistan Som",
	"symbol_native": "UZS",
	"decimal_digits": 0,
	"rounding": 0,
	"code": "UZS",
	"name_plural": "Uzbekistan som"
}, {
	"symbol": "Bs.F.",
	"name": "Venezuelan Bolívar",
	"symbol_native": "Bs.F.",
	"decimal_digits": 2,
	"rounding": 0,
	"code": "VEF",
	"name_plural": "Venezuelan bolívars"
}, {
	"symbol": "₫",
	"name": "Vietnamese Dong",
	"symbol_native": "₫",
	"decimal_digits": 0,
	"rounding": 0,
	"code": "VND",
	"name_plural": "Vietnamese dong"
}, {
	"symbol": "FCFA",
	"name": "CFA Franc BEAC",
	"symbol_native": "FCFA",
	"decimal_digits": 0,
	"rounding": 0,
	"code": "XAF",
	"name_plural": "CFA francs BEAC"
}, {
	"symbol": "CFA",
	"name": "CFA Franc BCEAO",
	"symbol_native": "CFA",
	"decimal_digits": 0,
	"rounding": 0,
	"code": "XOF",
	"name_plural": "CFA francs BCEAO"
}, {
	"symbol": "YR",
	"name": "Yemeni Rial",
	"symbol_native": "ر.ي.‏",
	"decimal_digits": 0,
	"rounding": 0,
	"code": "YER",
	"name_plural": "Yemeni rials"
}, {
	"symbol": "R",
	"name": "South African Rand",
	"symbol_native": "R",
	"decimal_digits": 2,
	"rounding": 0,
	"code": "ZAR",
	"name_plural": "South African rand"
}, {
	"symbol": "ZK",
	"name": "Zambian Kwacha",
	"symbol_native": "ZK",
	"decimal_digits": 0,
	"rounding": 0,
	"code": "ZMK",
	"name_plural": "Zambian kwachas"
}]

const countries = [
  { code: 'AD', "country": 'Andorra', phone: '376' },
  {
    code: 'AE',
    "country": 'United Arab Emirates',
    phone: '971',
  },
  { code: 'AF', "country": 'Afghanistan', phone: '93' },
  {
    code: 'AG',
    "country": 'Antigua and Barbuda',
    phone: '1-268',
  },
  { code: 'AI', "country": 'Anguilla', phone: '1-264' },
  { code: 'AL', "country": 'Albania', phone: '355' },
  { code: 'AM', "country": 'Armenia', phone: '374' },
  { code: 'AO', "country": 'Angola', phone: '244' },
  { code: 'AQ', "country": 'Antarctica', phone: '672' },
  { code: 'AR', "country": 'Argentina', phone: '54' },
  { code: 'AS', "country": 'American Samoa', phone: '1-684' },
  { code: 'AT', "country": 'Austria', phone: '43' },
  {
    code: 'AU',
    "country": 'Australia',
    phone: '61',
    suggested: true,
  },
  { code: 'AW', "country": 'Aruba', phone: '297' },
  { code: 'AX', "country": 'Alland Islands', phone: '358' },
  { code: 'AZ', "country": 'Azerbaijan', phone: '994' },
  {
    code: 'BA',
    "country": 'Bosnia and Herzegovina',
    phone: '387',
  },
  { code: 'BB', "country": 'Barbados', phone: '1-246' },
  { code: 'BD', "country": 'Bangladesh', phone: '880' },
  { code: 'BE', "country": 'Belgium', phone: '32' },
  { code: 'BF', "country": 'Burkina Faso', phone: '226' },
  { code: 'BG', "country": 'Bulgaria', phone: '359' },
  { code: 'BH', "country": 'Bahrain', phone: '973' },
  { code: 'BI', "country": 'Burundi', phone: '257' },
  { code: 'BJ', "country": 'Benin', phone: '229' },
  { code: 'BL', "country": 'Saint Barthelemy', phone: '590' },
  { code: 'BM', "country": 'Bermuda', phone: '1-441' },
  { code: 'BN', "country": 'Brunei Darussalam', phone: '673' },
  { code: 'BO', "country": 'Bolivia', phone: '591' },
  { code: 'BR', "country": 'Brazil', phone: '55' },
  { code: 'BS', "country": 'Bahamas', phone: '1-242' },
  { code: 'BT', "country": 'Bhutan', phone: '975' },
  { code: 'BV', "country": 'Bouvet Island', phone: '47' },
  { code: 'BW', "country": 'Botswana', phone: '267' },
  { code: 'BY', "country": 'Belarus', phone: '375' },
  { code: 'BZ', "country": 'Belize', phone: '501' },
  {
    code: 'CA',
    "country": 'Canada',
    phone: '1',
    suggested: true,
  },
  {
    code: 'CC',
    "country": 'Cocos (Keeling) Islands',
    phone: '61',
  },
  {
    code: 'CD',
    "country": 'Congo, Democratic Republic of the',
    phone: '243',
  },
  {
    code: 'CF',
    "country": 'Central African Republic',
    phone: '236',
  },
  {
    code: 'CG',
    "country": 'Congo, Republic of the',
    phone: '242',
  },
  { code: 'CH', "country": 'Switzerland', phone: '41' },
  { code: 'CI', "country": "Cote d'Ivoire", phone: '225' },
  { code: 'CK', "country": 'Cook Islands', phone: '682' },
  { code: 'CL', "country": 'Chile', phone: '56' },
  { code: 'CM', "country": 'Cameroon', phone: '237' },
  { code: 'CN', "country": 'China', phone: '86' },
  { code: 'CO', "country": 'Colombia', phone: '57' },
  { code: 'CR', "country": 'Costa Rica', phone: '506' },
  { code: 'CU', "country": 'Cuba', phone: '53' },
  { code: 'CV', "country": 'Cape Verde', phone: '238' },
  { code: 'CW', "country": 'Curacao', phone: '599' },
  { code: 'CX', "country": 'Christmas Island', phone: '61' },
  { code: 'CY', "country": 'Cyprus', phone: '357' },
  { code: 'CZ', "country": 'Czech Republic', phone: '420' },
  {
    code: 'DE',
    "country": 'Germany',
    phone: '49',
    suggested: true,
  },
  { code: 'DJ', "country": 'Djibouti', phone: '253' },
  { code: 'DK', "country": 'Denmark', phone: '45' },
  { code: 'DM', "country": 'Dominica', phone: '1-767' },
  {
    code: 'DO',
    "country": 'Dominican Republic',
    phone: '1-809',
  },
  { code: 'DZ', "country": 'Algeria', phone: '213' },
  { code: 'EC', "country": 'Ecuador', phone: '593' },
  { code: 'EE', "country": 'Estonia', phone: '372' },
  { code: 'EG', "country": 'Egypt', phone: '20' },
  { code: 'EH', "country": 'Western Sahara', phone: '212' },
  { code: 'ER', "country": 'Eritrea', phone: '291' },
  { code: 'ES', "country": 'Spain', phone: '34' },
  { code: 'ET', "country": 'Ethiopia', phone: '251' },
  { code: 'FI', "country": 'Finland', phone: '358' },
  { code: 'FJ', "country": 'Fiji', phone: '679' },
  {
    code: 'FK',
    "country": 'Falkland Islands (Malvinas)',
    phone: '500',
  },
  {
    code: 'FM',
    "country": 'Micronesia, Federated States of',
    phone: '691',
  },
  { code: 'FO', "country": 'Faroe Islands', phone: '298' },
  {
    code: 'FR',
    "country": 'France',
    phone: '33',
    suggested: true,
  },
  { code: 'GA', "country": 'Gabon', phone: '241' },
  { code: 'GB', "country": 'United Kingdom', phone: '44' },
  { code: 'GD', "country": 'Grenada', phone: '1-473' },
  { code: 'GE', "country": 'Georgia', phone: '995' },
  { code: 'GF', "country": 'French Guiana', phone: '594' },
  { code: 'GG', "country": 'Guernsey', phone: '44' },
  { code: 'GH', "country": 'Ghana', phone: '233' },
  { code: 'GI', "country": 'Gibraltar', phone: '350' },
  { code: 'GL', "country": 'Greenland', phone: '299' },
  { code: 'GM', "country": 'Gambia', phone: '220' },
  { code: 'GN', "country": 'Guinea', phone: '224' },
  { code: 'GP', "country": 'Guadeloupe', phone: '590' },
  { code: 'GQ', "country": 'Equatorial Guinea', phone: '240' },
  { code: 'GR', "country": 'Greece', phone: '30' },
  {
    code: 'GS',
    "country": 'South Georgia and the South Sandwich Islands',
    phone: '500',
  },
  { code: 'GT', "country": 'Guatemala', phone: '502' },
  { code: 'GU', "country": 'Guam', phone: '1-671' },
  { code: 'GW', "country": 'Guinea-Bissau', phone: '245' },
  { code: 'GY', "country": 'Guyana', phone: '592' },
  { code: 'HK', "country": 'Hong Kong', phone: '852' },
  {
    code: 'HM',
    "country": 'Heard Island and McDonald Islands',
    phone: '672',
  },
  { code: 'HN', "country": 'Honduras', phone: '504' },
  { code: 'HR', "country": 'Croatia', phone: '385' },
  { code: 'HT', "country": 'Haiti', phone: '509' },
  { code: 'HU', "country": 'Hungary', phone: '36' },
  { code: 'ID', "country": 'Indonesia', phone: '62' },
  { code: 'IE', "country": 'Ireland', phone: '353' },
  { code: 'IL', "country": 'Israel', phone: '972' },
  { code: 'IM', "country": 'Isle of Man', phone: '44' },
  { code: 'IN', "country": 'India', phone: '91' },
  {
    code: 'IO',
    "country": 'British Indian Ocean Territory',
    phone: '246',
  },
  { code: 'IQ', "country": 'Iraq', phone: '964' },
  {
    code: 'IR',
    "country": 'Iran, Islamic Republic of',
    phone: '98',
  },
  { code: 'IS', "country": 'Iceland', phone: '354' },
  { code: 'IT', "country": 'Italy', phone: '39' },
  { code: 'JE', "country": 'Jersey', phone: '44' },
  { code: 'JM', "country": 'Jamaica', phone: '1-876' },
  { code: 'JO', "country": 'Jordan', phone: '962' },
  {
    code: 'JP',
    "country": 'Japan',
    phone: '81',
    suggested: true,
  },
  { code: 'KE', "country": 'Kenya', phone: '254' },
  { code: 'KG', "country": 'Kyrgyzstan', phone: '996' },
  { code: 'KH', "country": 'Cambodia', phone: '855' },
  { code: 'KI', "country": 'Kiribati', phone: '686' },
  { code: 'KM', "country": 'Comoros', phone: '269' },
  {
    code: 'KN',
    "country": 'Saint Kitts and Nevis',
    phone: '1-869',
  },
  {
    code: 'KP',
    "country": "Korea, Democratic People's Republic of",
    phone: '850',
  },
  { code: 'KR', "country": 'Korea, Republic of', phone: '82' },
  { code: 'KW', "country": 'Kuwait', phone: '965' },
  { code: 'KY', "country": 'Cayman Islands', phone: '1-345' },
  { code: 'KZ', "country": 'Kazakhstan', phone: '7' },
  {
    code: 'LA',
    "country": "Lao People's Democratic Republic",
    phone: '856',
  },
  { code: 'LB', "country": 'Lebanon', phone: '961' },
  { code: 'LC', "country": 'Saint Lucia', phone: '1-758' },
  { code: 'LI', "country": 'Liechtenstein', phone: '423' },
  { code: 'LK', "country": 'Sri Lanka', phone: '94' },
  { code: 'LR', "country": 'Liberia', phone: '231' },
  { code: 'LS', "country": 'Lesotho', phone: '266' },
  { code: 'LT', "country": 'Lithuania', phone: '370' },
  { code: 'LU', "country": 'Luxembourg', phone: '352' },
  { code: 'LV', "country": 'Latvia', phone: '371' },
  { code: 'LY', "country": 'Libya', phone: '218' },
  { code: 'MA', "country": 'Morocco', phone: '212' },
  { code: 'MC', "country": 'Monaco', phone: '377' },
  {
    code: 'MD',
    "country": 'Moldova, Republic of',
    phone: '373',
  },
  { code: 'ME', "country": 'Montenegro', phone: '382' },
  {
    code: 'MF',
    "country": 'Saint Martin (French part)',
    phone: '590',
  },
  { code: 'MG', "country": 'Madagascar', phone: '261' },
  { code: 'MH', "country": 'Marshall Islands', phone: '692' },
  {
    code: 'MK',
    "country": 'Macedonia, the Former Yugoslav Republic of',
    phone: '389',
  },
  { code: 'ML', "country": 'Mali', phone: '223' },
  { code: 'MM', "country": 'Myanmar', phone: '95' },
  { code: 'MN', "country": 'Mongolia', phone: '976' },
  { code: 'MO', "country": 'Macao', phone: '853' },
  {
    code: 'MP',
    "country": 'Northern Mariana Islands',
    phone: '1-670',
  },
  { code: 'MQ', "country": 'Martinique', phone: '596' },
  { code: 'MR', "country": 'Mauritania', phone: '222' },
  { code: 'MS', "country": 'Montserrat', phone: '1-664' },
  { code: 'MT', "country": 'Malta', phone: '356' },
  { code: 'MU', "country": 'Mauritius', phone: '230' },
  { code: 'MV', "country": 'Maldives', phone: '960' },
  { code: 'MW', "country": 'Malawi', phone: '265' },
  { code: 'MX', "country": 'Mexico', phone: '52' },
  { code: 'MY', "country": 'Malaysia', phone: '60' },
  { code: 'MZ', "country": 'Mozambique', phone: '258' },
  { code: 'NA', "country": 'Namibia', phone: '264' },
  { code: 'NC', "country": 'New Caledonia', phone: '687' },
  { code: 'NE', "country": 'Niger', phone: '227' },
  { code: 'NF', "country": 'Norfolk Island', phone: '672' },
  { code: 'NG', "country": 'Nigeria', phone: '234' },
  { code: 'NI', "country": 'Nicaragua', phone: '505' },
  { code: 'NL', "country": 'Netherlands', phone: '31' },
  { code: 'NO', "country": 'Norway', phone: '47' },
  { code: 'NP', "country": 'Nepal', phone: '977' },
  { code: 'NR', "country": 'Nauru', phone: '674' },
  { code: 'NU', "country": 'Niue', phone: '683' },
  { code: 'NZ', "country": 'New Zealand', phone: '64' },
  { code: 'OM', "country": 'Oman', phone: '968' },
  { code: 'PA', "country": 'Panama', phone: '507' },
  { code: 'PE', "country": 'Peru', phone: '51' },
  { code: 'PF', "country": 'French Polynesia', phone: '689' },
  { code: 'PG', "country": 'Papua New Guinea', phone: '675' },
  { code: 'PH', "country": 'Philippines', phone: '63' },
  { code: 'PK', "country": 'Pakistan', phone: '92' },
  { code: 'PL', "country": 'Poland', phone: '48' },
  {
    code: 'PM',
    "country": 'Saint Pierre and Miquelon',
    phone: '508',
  },
  { code: 'PN', "country": 'Pitcairn', phone: '870' },
  { code: 'PR', "country": 'Puerto Rico', phone: '1' },
  {
    code: 'PS',
    "country": 'Palestine, State of',
    phone: '970',
  },
  { code: 'PT', "country": 'Portugal', phone: '351' },
  { code: 'PW', "country": 'Palau', phone: '680' },
  { code: 'PY', "country": 'Paraguay', phone: '595' },
  { code: 'QA', "country": 'Qatar', phone: '974' },
  { code: 'RE', "country": 'Reunion', phone: '262' },
  { code: 'RO', "country": 'Romania', phone: '40' },
  { code: 'RS', "country": 'Serbia', phone: '381' },
  { code: 'RU', "country": 'Russian Federation', phone: '7' },
  { code: 'RW', "country": 'Rwanda', phone: '250' },
  { code: 'SA', "country": 'Saudi Arabia', phone: '966' },
  { code: 'SB', "country": 'Solomon Islands', phone: '677' },
  { code: 'SC', "country": 'Seychelles', phone: '248' },
  { code: 'SD', "country": 'Sudan', phone: '249' },
  { code: 'SE', "country": 'Sweden', phone: '46' },
  { code: 'SG', "country": 'Singapore', phone: '65' },
  { code: 'SH', "country": 'Saint Helena', phone: '290' },
  { code: 'SI', "country": 'Slovenia', phone: '386' },
  {
    code: 'SJ',
    "country": 'Svalbard and Jan Mayen',
    phone: '47',
  },
  { code: 'SK', "country": 'Slovakia', phone: '421' },
  { code: 'SL', "country": 'Sierra Leone', phone: '232' },
  { code: 'SM', "country": 'San Marino', phone: '378' },
  { code: 'SN', "country": 'Senegal', phone: '221' },
  { code: 'SO', "country": 'Somalia', phone: '252' },
  { code: 'SR', "country": 'Suriname', phone: '597' },
  { code: 'SS', "country": 'South Sudan', phone: '211' },
  {
    code: 'ST',
    "country": 'Sao Tome and Principe',
    phone: '239',
  },
  { code: 'SV', "country": 'El Salvador', phone: '503' },
  {
    code: 'SX',
    "country": 'Sint Maarten (Dutch part)',
    phone: '1-721',
  },
  {
    code: 'SY',
    "country": 'Syrian Arab Republic',
    phone: '963',
  },
  { code: 'SZ', "country": 'Swaziland', phone: '268' },
  {
    code: 'TC',
    "country": 'Turks and Caicos Islands',
    phone: '1-649',
  },
  { code: 'TD', "country": 'Chad', phone: '235' },
  {
    code: 'TF',
    "country": 'French Southern Territories',
    phone: '262',
  },
  { code: 'TG', "country": 'Togo', phone: '228' },
  { code: 'TH', "country": 'Thailand', phone: '66' },
  { code: 'TJ', "country": 'Tajikistan', phone: '992' },
  { code: 'TK', "country": 'Tokelau', phone: '690' },
  { code: 'TL', "country": 'Timor-Leste', phone: '670' },
  { code: 'TM', "country": 'Turkmenistan', phone: '993' },
  { code: 'TN', "country": 'Tunisia', phone: '216' },
  { code: 'TO', "country": 'Tonga', phone: '676' },
  { code: 'TR', "country": 'Turkey', phone: '90' },
  {
    code: 'TT',
    "country": 'Trinidad and Tobago',
    phone: '1-868',
  },
  { code: 'TV', "country": 'Tuvalu', phone: '688' },
  {
    code: 'TW',
    "country": 'Taiwan, Republic of China',
    phone: '886',
  },
  {
    code: 'TZ',
    "country": 'United Republic of Tanzania',
    phone: '255',
  },
  { code: 'UA', "country": 'Ukraine', phone: '380' },
  { code: 'UG', "country": 'Uganda', phone: '256' },
  {
    code: 'US',
    "country": 'United States',
    phone: '1',
    suggested: true,
  },
  { code: 'UY', "country": 'Uruguay', phone: '598' },
  { code: 'UZ', "country": 'Uzbekistan', phone: '998' },
  {
    code: 'VA',
    "country": 'Holy See (Vatican City State)',
    phone: '379',
  },
  {
    code: 'VC',
    "country": 'Saint Vincent and the Grenadines',
    phone: '1-784',
  },
  { code: 'VE', "country": 'Venezuela', phone: '58' },
  {
    code: 'VG',
    "country": 'British Virgin Islands',
    phone: '1-284',
  },
  {
    code: 'VI',
    "country": 'US Virgin Islands',
    phone: '1-340',
  },
  { code: 'VN', "country": 'Vietnam', phone: '84' },
  { code: 'VU', "country": 'Vanuatu', phone: '678' },
  { code: 'WF', "country": 'Wallis and Futuna', phone: '681' },
  { code: 'WS', "country": 'Samoa', phone: '685' },
  { code: 'XK', "country": 'Kosovo', phone: '383' },
  { code: 'YE', "country": 'Yemen', phone: '967' },
  { code: 'YT', "country": 'Mayotte', phone: '262' },
  { code: 'ZA', "country": 'South Africa', phone: '27' },
  { code: 'ZM', "country": 'Zambia', phone: '260' },
  { code: 'ZW', "country": 'Zimbabwe', phone: '263' },
];
export default ModifyCountry;